class BlackFridayHeader {
  constructor(container) {
    this.container = container;
    if (!this.container) return;

    this.countdownElement = this.container.querySelector('.w-blackfriday-header__countdown');
    if (!this.countdownElement) return;

    this.countdownEnd = this.countdownElement.dataset.countdownEnd;
    this.daysElement = this.countdownElement.querySelector('[data-unit="days"]');
    this.hoursElement = this.countdownElement.querySelector('[data-unit="hours"]');
    this.minutesElement = this.countdownElement.querySelector('[data-unit="minutes"]');
    this.secondsElement = this.countdownElement.querySelector('[data-unit="seconds"]');

    this.startCountdown();
    this.initCTAButton();
  }

  initCTAButton() {
    const ctaButton = this.container.querySelector('.w-blackfriday-header__cta');
    if (!ctaButton) return;

    ctaButton.addEventListener('click', (e) => {
      e.preventDefault();

      const firstAtcBundle = document.querySelector('.atc-bundle-sor');
      if (firstAtcBundle) {
        firstAtcBundle.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  }

  startCountdown() {
    if (!this.countdownEnd) return;

    const updateCountdown = () => {
      const now = new Date().getTime();
      const endDate = new Date(this.countdownEnd.replace(' ', 'T')).getTime();
      const distance = endDate - now;

      if (distance < 0) {
        if (this.daysElement) this.daysElement.textContent = '00';
        if (this.hoursElement) this.hoursElement.textContent = '00';
        if (this.minutesElement) this.minutesElement.textContent = '00';
        if (this.secondsElement) this.secondsElement.textContent = '00';
        if (this.countdownInterval) clearInterval(this.countdownInterval);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (this.daysElement) this.daysElement.textContent = String(days).padStart(2, '0');
      if (this.hoursElement) this.hoursElement.textContent = String(hours).padStart(2, '0');
      if (this.minutesElement) this.minutesElement.textContent = String(minutes).padStart(2, '0');
      if (this.secondsElement) this.secondsElement.textContent = String(seconds).padStart(2, '0');
    };

    updateCountdown();
    this.countdownInterval = setInterval(updateCountdown, 1000);
  }

  destroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }
}

class BlackFridayStickyBar {
  constructor(container) {
    this.container = container;
    if (!this.container) return;

    this.buttons = this.container.querySelectorAll('.w-blackfriday-sticky-bar__button');
    this.buttonsWrapper = this.container.querySelector('.w-blackfriday-sticky-bar__buttons-wrapper');
    this.scrollbarThumb = this.container.querySelector('.w-blackfriday-sticky-bar__scrollbar-thumb');

    this.bindEvents();
    this.updateScrollIndicator();
    this.checkStickyBarVisibility();
  }

  bindEvents() {
    this.buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        this.handleButtonClick(e);
      });
    });

    if (this.buttonsWrapper) {
      this.buttonsWrapper.addEventListener('scroll', () => {
        this.updateScrollIndicator();
      });
    }

    window.addEventListener('scroll', () => {
      this.checkStickyBarVisibility();
    });

    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.updateScrollIndicator();
        this.checkStickyBarVisibility();
      }, 100);
    });
  }

  checkStickyBarVisibility() {
    const atcBundleSections = document.querySelectorAll('.atc-bundle-sor');
    if (atcBundleSections.length === 0) return;

    const lastBundleSection = atcBundleSections[atcBundleSections.length - 1];
    const lastBundleParent = lastBundleSection.closest('.shopify-section');
    if (!lastBundleParent) return;

    const rect = lastBundleParent.getBoundingClientRect();
    const headerWrapper = document.querySelector('.w-blackfriday-header-wrapper');
    const headerHeight = headerWrapper ? headerWrapper.offsetHeight : 0;

    if (rect.bottom <= headerHeight) {
      this.container.classList.add('is-visible');
    } else {
      this.container.classList.remove('is-visible');
    }
  }

  handleButtonClick(e) {
    const button = e.currentTarget;
    const productId = button.dataset.productId;

    this.buttons.forEach(btn => {
      btn.classList.remove('w-blackfriday-sticky-bar__button--active');
    });
    button.classList.add('w-blackfriday-sticky-bar__button--active');

    const headerWrapper = document.querySelector('.w-blackfriday-header-wrapper');
    const headerHeight = headerWrapper ? headerWrapper.offsetHeight : 0;

    if (productId) {
      const productSections = document.querySelectorAll('.atc-bundle-sor');
      productSections.forEach(section => {
        if (section.dataset.productId === productId) {
          const parent = section.closest('.shopify-section');
          if (parent) {
            const targetPosition = parent.getBoundingClientRect().top + window.pageYOffset - headerHeight;
            window.scrollTo({ top: targetPosition, behavior: 'smooth' });
          }
        }
      });
    }
  }

  updateScrollIndicator() {
    if (!this.buttonsWrapper || !this.scrollbarThumb) return;
    if (window.innerWidth > 990) return;

    const scrollPercentage = this.buttonsWrapper.scrollLeft /
      (this.buttonsWrapper.scrollWidth - this.buttonsWrapper.clientWidth);

    const maxTranslate = this.scrollbarThumb.parentElement.clientWidth - this.scrollbarThumb.clientWidth;
    this.scrollbarThumb.style.transform = `translateX(${scrollPercentage * maxTranslate}px)`;
  }
}

function initializeBlackFridayHeader() {
  const headerSections = document.querySelectorAll('.w-blackfriday-header');
  headerSections.forEach(section => {
    if (section.blackFridayHeaderInstance) {
      section.blackFridayHeaderInstance.destroy();
    }
    section.blackFridayHeaderInstance = new BlackFridayHeader(section);
  });

  const stickyBarSections = document.querySelectorAll('.w-blackfriday-sticky-bar');
  stickyBarSections.forEach(section => {
    if (!section.blackFridayStickyBarInstance) {
      section.blackFridayStickyBarInstance = new BlackFridayStickyBar(section);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeBlackFridayHeader();
});

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.w-blackfriday-header') || e.target.querySelector('.w-blackfriday-sticky-bar')) {
    initializeBlackFridayHeader();
  }
});

document.addEventListener('shopify:section:unload', (e) => {
  const header = e.target.querySelector('.w-blackfriday-header');
  if (header && header.blackFridayHeaderInstance) {
    header.blackFridayHeaderInstance.destroy();
  }
});
